<template>
  <div class="about" id="quotaReviewList">
    <div style="text-align: left">
      <el-form :inline="true" :model="queryForm" class="demo-form-inline">
        <el-form-item label="公司名称：">
          <el-input v-model="queryForm.name" placeholder="请输入公司名称查询" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onQuery" icon="el-icon-search">查询</el-button>
          <el-button type="primary" @click="onReset" icon="el-icon-refresh-right">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align: left;margin-bottom: 20px;">
      <el-button type="primary" icon="el-icon-download" @click="exportTable">导出</el-button>
    </div>
   
    <div>
        <el-table
        :data="tableData"
        :header-cell-style="tableHeader"
        :cell-style="tableCell"
        border
        fit
        style="width: 100%">
        <el-table-column  type="index"  label="序号" />
        <el-table-column :show-overflow-tooltip="true" prop="accountName"  label="公司名称" /> 
        <el-table-column prop="walletId" label="子账号号码" />
        <el-table-column label="资金余额(元)" align="center">
          <template slot-scope="scope" >{{accDiv(scope.row.amount,100)}}</template>
        </el-table-column> 
        <el-table-column prop="state" label="状态" align="center"  :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 'auditing'">待生效</span>
            <span v-if="scope.row.state == 'succeeded'">已生效</span>
            <span v-if="scope.row.state == 'failed'">失效</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" />
        <!-- <el-table-column fixed="right" label="操作" >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openUploadFrom(scope.row)" style="color: #09BF88">修改</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
      
      id="page"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        @prev-click="currentChange"
        @next-click="currentChange"
        :page-sizes="[5, 10, 20]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    
  </div>
</template>

<script>

export default {
    data() {
      return {
        headData: {
          createTime: '',
          groupId: '',
          groupName: '',
          id: '',
          latestApprovalTime: '',
          latestOperator: '',
          productId: '',
          productName: '',
          proofId: '',
          state: undefined,
          submitor: '',
          tenantId: '',
          uploadTime: ''
        },
        summaryStateList: null,
        tableLoading: true,
        loadDate:'',
        tableData: [],
        logTableData: null,
        input: '',
        queryForm: {
          id: '',
          idno: '',
          name: '',
          account:'',
          pageNo: 1,
          pageSize: 10,
          sessionId: this.$getCookie("sessionId"),
        },
        total:0,
        dialogFormVisible: false,
        updateForm: {
          id: '',
          newSalaryAmount: undefined,
          remark: '',
          sessionId: ''
        },
        rules: {
          newSalaryAmount: [
            { required: true, message: '新的金额不能为空！', trigger: 'blur' }
          ]
        }
      }
    },
    async created(){
      // 获取数组字典
     
      await this.loadInfo();
      // this.loadDate = this.$route.params.date;
      await this.loadTable();
    },
    methods: {
      // 加载当前表格头
      async loadInfo(){
        // await this.api.summaryApi.getById({proofId: this.queryForm.proofId}).then(res =>{
        //   res = res.data;
        //   if(res.status = 200){
        //     this.headData = res.data;
        //   }else{
        //     this.$message.error('数据加载失败！');
        //   }
        // })
      },
      // 加载表格
      async loadTable(){
        // .bind(this);
        let flag = this;
        await this.api.accountApi.subAccountList(this.queryForm).then((res) => {
				res = res.data
				console.log("----账户列表-----",res);
				if(res.code == 200){
					flag.tableData = res.data.data.records;
					flag.total = res.data.total
				}else{
            this.tableData =  null;
            this.total = 0;
            this.$message.error(res.msg);
          }
			})
    },
      async exportTable(){
        console.log("导出下载");
        await this.api.salaryApi.downloadSubaccountLog().then(res =>{
          console.log("导出下载----",res)
          let fileNameEncode = "子账号数据.xlsx";
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel"});
          console.log(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download",  decodeURIComponent(fileNameEncode));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
      },

      // 条件查询
      onQuery() {
        this.loadTable();
      },
      
      // 重置表单
      resetForm(form){
        this.$refs[form].resetFields();
      },
      // 重置
      onReset(){
        this.queryForm.name='';
        this.queryForm.account='';
        this.loadTable();
      },
      //current-change
      currentChange(page){
        this.queryForm.pageNo = page;
        this.loadTable();
      },

      // size-change
      sizeChange(size){
        this.queryForm.pageSize = size;
        this.loadTable();
      },
      tableHeader(column) {
      return "height:36px;background-color:#fafafa;color:#333333;padding:0";
      },
      tableCell(column) {
        return "height:40px;background-color:#fafafa;color:#000000;padding:0";
      },
      isEntity(val){
        if(val == null || val == undefined || val === ''){
            return true;
        }else{
            return false;
        }
      },
    }
}
</script>

<style scoped>



#page {
  float: right;
  margin-top: 15px;
}

#quotaReviewList {
  overflow: hidden;
  background-color: white;
  padding: 15px 20px 100px;
}

>>> .el-dialog__body {
  border-top: 1px solid rgba(228, 228, 228, 1);
  border-bottom: 1px solid rgb(228, 228, 228, 1);
  padding-left: 0;
  padding-right: 0;
}

>>> .el-drawer.rtl {
  overflow: scroll;
}

.wageadjustment{
  margin: 0 50px;
}

</style>

